import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { CanActivate, CanActivateChild } from '@angular/router'
import { AuthService } from './authentication.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { isTruthy } from './is-truthy'

@Injectable()
export class RouteAuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private authService: AuthService) {}

  /***
   * This method implement CanActivate interface and give or deny access to route
   * @returns {boolean}
   */
  canActivate(): Observable<boolean> {
    return this.isAuthenticated()
  }

  /***
     * This method implement CanActivateChild interface and give or deny access
     * to route children
     * Route children are routes inside 'children' property.
     * When you set canActivateChild guard for parent route it add this guard to
     * property 'canActivate' of each children routes. For example:
       Route: {
            path: '',
            component: LayoutComponent,
            canActivateChild: [ RouteAuthGuard ],
            children: [
                { path: 'dashboard', component: Dashboard },
            ]
       }
     * in this example for child route 'dashboard' canActivate property will be automatically
     * set as canActivate: [ RouteAuthGuard ]
     * @returns {boolean}
     */
  canActivateChild(): Observable<boolean> {
    return this.isAuthenticated()
  }

  /***
   * Returns true if the user is authenticated, this will determine paths that the
   * user can access
   * @returns {boolean}
   */
  isAuthenticated(): Observable<boolean> {
    return this.authService.autheticate().pipe(
      map((result) => {
        const isUserExist = isTruthy(result.user)
        if (!isUserExist) {
          this.router.navigate(['/login'])
        }
        return isUserExist
      }),
    )
  }
}
